<template>
  <CRow>
    <CCol>
      <template v-if="message.status">
        <CAlert maxlength="255" :color="message.status" closeButton>
          {{ message.text }}
        </CAlert>
        <h2 class="h1 mb-5" :class="`text-${message.status}`"></h2>
      </template>
      <CForm autocomplete="OFF" @submit.prevent="register">
        <h1 class="mb-5">
          {{ $t('auth.newRegister.header1.sign-up') }}
        </h1>
        <h4 class="mb-4">{{ $t('auth.newRegister.header4.welcome') }},</h4>
        <!-- <CRow :gutters="false" v-if="!external">
          <SocialLogin />
        </CRow> -->
        <CRow>
          <CCol md="6">
            <CInput
              class="mb-0"
              :label="$t('auth.newRegister.input.name')"
              type="text"
              maxlength="255"
              id="namme"
              addLabelClasses="mt-1 required"
              :value.sync="$v.user.name.$model"
              :isValid="checkIfValid('name')"
              :invalidFeedback="assignInvalidFeedback($v.user.name)"
              aria-describedby=""
              :placeholder="$t('auth.newRegister.input.name')"
              :readonly="external"
            />
          </CCol>
          <CCol md="6">
            <CInput
              class="mb-0"
              :label="$t('auth.newRegister.input.email')"
              type="email"
              id="email"
              maxlength="255"
              disabled
              addLabelClasses="mt-1 required"
              :value.sync="$v.user.email.$model"
              :isValid="checkIfValid('email')"
              :invalidFeedback="assignInvalidFeedback($v.user.email)"
              aria-describedby=""
              :placeholder="$t('auth.newRegister.input.email')"
              :readonly="external"
            />
          </CCol>
          <CCol md="6" class="mt-2">
            <CForm autocomplete="off">
              <CInput
                v-if="!external"
                class="mb-0"
                :label="$t('auth.newRegister.input.password')"
                :type="typeInputPassword"
                addLabelClasses="mt-1 required"
                :value.sync="$v.user.password.$model"
                :isValid="checkIfValid('password')"
                :invalidFeedback="assignInvalidFeedback($v.user.password)"
                id="password"
                autocomplete="off"
                v-focus="focused"
                @focus="focused = true"
                @blur="focused = false"
                placeholder=""
              >
                <template #append>
                  <CButton @click="showPassword('typeInputPassword')">
                    <i class="far" :class="`fa-${iconInputPassword}`"></i>
                  </CButton>
                </template>
              </CInput>
            </CForm>
            <div v-show="focused" class="text-muted checkPassword">
              <p class="text-muted mb-1">{{ $t('auth.newRegister.text.password-requirements') }}</p>
              <ul class="p-0 font-smaller checkPassword__list">
                <li v-for="(item, i) in listCheckPassword" :key="i" class="font-smaller checkPassword__item" :class="{ 'is-valid': item.isValid }">
                  * {{ item.name }}
                </li>
              </ul>
            </div>
          </CCol>
          <CCol md="6" class="mt-2">
            <CForm autocomplete="off">
              <CInput
                v-if="!external"
                class="mb-0"
                autocomplete="off"
                :label="$t('auth.newRegister.input.confirmPassword')"
                :type="typeInputConfirmPassword"
                addLabelClasses="mt-1 required"
                :value.sync="$v.user.confirmPassword.$model"
                :isValid="checkIfValid('confirmPassword')"
                :invalidFeedback="fieldInvalidationReturn($v.user.confirmPassword, 'password')"
                id="confirmPassword"
              >
                <template #append>
                  <CButton @click="showPassword('typeInputConfirmPassword')">
                    <i class="far" :class="`fa-${iconInputConfirmPassword}`"></i>
                  </CButton>
                </template>
              </CInput>
            </CForm>
          </CCol>
          <CCol md="6" class="mt-2">
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('auth.newRegister.input.mobile-number') }}
                </label>
              </CCol>
              <CCol sm="12">
                <CRow sm="12" class="d-flex" :gutters="false">
                  <CCol sm="6" class="mr-1">
                    <v-select
                      class="mb-0 no-close select-country-code"
                      :options="optionsCountries"
                      v-model="$v.user.phoneCountryIndicator.$model"
                      :isValid="checkIfValid('phoneCountryIndicator')"
                      id="countrySelected"
                      :placeholder="$t('general.input.placeholder.country-code')"
                    >
                      <template #selected-option="{ label, flag }">
                        <div class="d-flex align-items-center">
                          <img :src="flag" alt="" width="25" />
                          <span class="ml-2">{{ label }}</span>
                        </div>
                      </template>
                      <template v-slot:option="option">
                        <img :src="option.flag" width="20" height="auto" />
                        {{ option.label }}
                      </template>
                    </v-select>
                  </CCol>
                  <CCol>
                    <CInput
                      type="text"
                      name="phoneNumber"
                      id="phoneNumber"
                      addInputClasses="pr-2"
                      maxlength="15"
                      :value.sync="$v.user.phoneNumber.$model"
                      @keypress="isNumber($event)"
                      :isValid="checkIfValid('phoneNumber')"
                      :invalidFeedback="assignInvalidFeedback($v.user.phoneNumber)"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol md="6" class="mt-2">
            <CInput
              class="mb-0"
              :label="$t('auth.newRegister.input.company-name')"
              type="text"
              addLabelClasses="mt-1 required"
              :maxlength="30"
              :value.sync="$v.user.companyName.$model"
              :isValid="checkIfValid('companyName')"
              :invalidFeedback="assignInvalidFeedback($v.user.companyName)"
              id="companyName"
              :placeholder="$t('auth.newRegister.input.company-name')"
              disabled
            />
          </CCol>
          <CCol sm="12" class="mb-1 mt-4">
            <div class="d-flex align-content-center">
              <CInputCheckbox
                type="checkbox"
                :checked.sync="$v.user.acceptedTerms.$model"
                :isValid="checkIfValid('acceptedTerms')"
                :invalidFeedback="''"
                id="acceptedTerms"
                placeholder=""
                custom
              />
              <p class="text-muted font-smaller m-0">
                {{ $t('auth.newRegister.text.sing-in-accept1') }}
                <CLink class="mx-2 text-primary" to="/login">
                  <span class="link">{{ $t('auth.newRegister.link.terms-of-service') }}</span>
                </CLink>
                {{ $t('auth.newRegister.text.sing-in-accept2') }}
                <CLink class="mx-2 text-primary" to="/login">
                  <span class="link">{{ $t('auth.newRegister.link.privacy-police') }}</span>
                </CLink>
              </p>
            </div>
            <div class="d-flex align-content-center">
              <CInputCheckbox
                type="checkbox"
                :checked.sync="$v.user.acceptedCommunications.$model"
                :isValid="checkIfValid('acceptedCommunications')"
                :invalidFeedback="''"
                id="acceptedCommunications"
                placeholder=""
                custom
              />
              <p class="text-muted font-smaller m-0">
                {{ $t('auth.newRegister.text.agree-marketing') }}
              </p>
            </div>
          </CCol>
          <CCol sm="12" md="4">
            <CButton :disabled="!isValid || submitted" type="submit" class="btn btn-primary btn-block font-weight-bold font-2xl mt-sm-2 mt-md-4">
              {{ $t('auth.newRegister.button.sign-up') }}
            </CButton>
          </CCol>
        </CRow>
      </CForm>
    </CCol>
  </CRow>
</template>
<script>
//TODO remover para produção
import { CallingCodeMoreFlag } from '@/utils/countriesUtils.js'
import services from '@/services.js'
import { mixin as focusMixin } from 'vue-focus'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email, requiredIf, sameAs } from 'vuelidate/lib/validators'
import { getInvalidFeedback } from '@/utils/vuelidate.js'
import { handleErrorCode } from '@/utils/errorHandling.js'
import vSelect from 'vue-select'

export default {
  name: 'Register',
  components: {
    vSelect,
  },
  data() {
    return {
      external: false,
      typeInputPassword: 'password',
      typeInputConfirmPassword: 'password',
      focused: false,
      message: [],
      submitted: false,
      countrySelected: '',
      inviteId: null,
      listCheckPassword: {
        hasLowerCase: { name: this.$t('auth.newRegister.text.lower-case'), isValid: false },
        hasSpecial: { name: this.$t('auth.newRegister.text.especial-character'), isValid: false },
        hasUppercase: {
          name: this.$t('auth.newRegister.text.uppercase-character'),
          isValid: false,
        },
        hasMinNumber: { name: this.$t('auth.newRegister.text.minimal-character'), isValid: false },
        hasNumber: { name: this.$t('auth.newRegister.text.one-number'), isValid: false },
      },
      user: {
        name: '',
        email: '',
        phoneCountryIndicator: '',
        phoneNumber: '',
        password: '',
        confirmPassword: '',
        companyName: '',
        acceptedTerms: null,
        acceptedCommunications: false,
        signupType: 'internal',
      },
      reloadField: true,
    }
  },
  mixins: [validationMixin, focusMixin],
  validations: {
    user: {
      name: {
        required,
        maxLength: maxLength(30),
      },
      email: {
        required,
        email,
        maxLength: maxLength(255),
      },
      phoneCountryIndicator: {
        required,
        minLength: minLength(1),
      },
      phoneNumber: {
        required,
        maxLength: maxLength(255),
      },
      password: {
        required: requiredIf(function () {
          return !this.external
        }),
        strongPassword(password) {
          // Se for login externo, remove a necessidade de validar a força da senha
          if (this.external) return true

          return (
            /[a-z]/.test(password) && // checks for a-z
            /[A-Z]/.test(password) && // checks for A-Z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) && // checks for special char
            password.length >= 8
          )
        },
      },
      confirmPassword: {
        required,
        sameAs: sameAs('password'),
      },
      companyName: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(255),
      },
      acceptedTerms: {
        required,
        checked: (value) => value === true,
      },
      acceptedCommunications: {
        required: false,
      },
    },
  },
  mounted() {
    if (this.$route.query.lang) {
      switch (this.$route.query.lang) {
        case 'en':
          this.$root.$emit('chooseLang', 'en-US')
          break
        case 'pt':
          this.$root.$emit('chooseLang', 'pt-PT')
          break
        default:
          break
      }
    }
    if (this.$route.params.inviteId) {
      this.$store.commit('auth/AUTH_REQUEST')

      this.inviteId = this.$route.params.inviteId
      this.loadData()
    } else {
      this.$router.push({ name: 'Login' })
    }
  },

  methods: {
    assignInvalidFeedback(validationObj) {
      return getInvalidFeedback(validationObj)
    },

    checkIfValid(fieldName) {
      const field = this.$v.user[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    loadData() {
      services
        .getInviteData(this.inviteId)
        .then((res) => {
          for (var i in res.data.data) {
            this.user[i] = res.data.data[i]
          }
        })
        .catch((error) => {
          this.message = {
            status: 'danger',
            text: error.response.data.message,
          }
          setTimeout(() => this.$router.push({ name: 'Login' }), 3000)
        })
        .finally(() => {
          this.$store.commit('auth/AUTH_INVITE_LOADED')
        })
    },

    register() {
      if (!this.isValid) {
        return
      }

      this.message = []

      const obj = {
        name: this.user.name,
        email: this.user.email,
        phoneCountryIndicator: Number(this.user.phoneCountryIndicator.value),
        phoneNumber: this.user.phoneNumber,
        password: this.user.password,
        companyName: this.user.companyName,
        acceptedTerms: this.user.acceptedTerms,
        acceptedCommunications: this.user.acceptedCommunications,
      }

      this.$store
        .dispatch('auth/registerWithInvite', { inviteId: this.inviteId, body: obj })
        .then(() => {
          this.$router.push({ name: 'ConfirmRegisterInvite' })
          // this.message = {
          //   status: 'success',
          //   message: this.$t('auth.newRegister.message.check-email')
          // }

          // setTimeout(() => {
          //   this.$router.push({ name: 'ConfirmRegisterInvite' })
          // }, 1000)
        })
        .catch((error) => {
          const errorCode = error?.data?.errorCode || error?.data?.ErrorCode

          this.message = {
            status: 'danger',
            text: handleErrorCode(errorCode),
          }
        })
    },

    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    //TODO add a um mixin ou component
    showPassword(field) {
      if (this[field] === 'password') {
        this[field] = 'text'
      } else {
        this[field] = 'password'
      }
    },

    fieldInvalidationReturn(field, termForTranslation) {
      if (!field.required) {
        return this.$t('auth.newRegister.inputFeedback.required')
      }

      if (!field.sameAs) {
        return this.$t(`auth.newRegister.inputFeedback.sameAs-${termForTranslation}`)
      }
    },
  },
  computed: {
    status() {
      return this.$store.getters['auth/authStatus']
    },

    isValid() {
      return !this.$v.user.$invalid
    },

    iconInputPassword() {
      return this.typeInputPassword === 'password' ? 'eye-slash' : 'eye'
    },

    iconInputConfirmPassword() {
      return this.typeInputConfirmPassword === 'password' ? 'eye-slash' : 'eye'
    },

    optionsCountries() {
      return CallingCodeMoreFlag(this)
    },
  },
  watch: {
    'user.password': {
      deep: true,
      handler() {
        this.listCheckPassword.hasLowerCase.isValid = /[a-z]/.test(this.user.password) ? true : null
        this.listCheckPassword.hasUppercase.isValid = /[A-Z]/.test(this.user.password) ? true : null
        this.listCheckPassword.hasNumber.isValid = /[0-9]/.test(this.user.password) ? true : null
        this.listCheckPassword.hasSpecial.isValid = /\W|_/.test(this.user.password) ? true : null
        this.listCheckPassword.hasMinNumber.isValid = this.user.password.length >= 8 ? true : null
      },
    },
  },
}
</script>
<style lang="scss" scoped>
//TODO o componente deve aceitar variaveis de mixins @extend %shadow-sm;
.link {
  text-decoration: underline;
}
</style>
<style lang="scss">
.v-select .vs__dropdown-toggle,
.select-country-code {
  height: 50px;
}
</style>
